import React, { useRef, useState } from 'react';
import { getFilterFormFields } from './constant';
import { Card, CardBody } from 'reactstrap';
import { ReactComponent as BackArrow } from "assets/img/svg/BackArrow.svg";
import APopover from 'views/pages/manage/common/a-popover';
import Filters from './Filters';
import AButton from 'views/pages/manage/common/form-fields-mui/AButton';
import { useHistory } from 'react-router-dom';
import ListComponent from './ListComponent';
import CustomChip from 'views/pages/manage/common/customChip/CustomChip';
import { endpoint } from 'views/pages/manage/common/constant';
import { successToast } from 'views/pages/manage/common/utils/methods/toasterFunctions/function';
import { updateRequest } from 'views/pages/manage/edpOps/constant/common';
import { fetchAllPostPromisedData } from 'views/pages/manage/common/utils/methods/commonMethods/utilityMethod';
import moment from 'moment';
// import APopover from '../../common/a-popover';
const WeekwiseCalculationList = ({
    globalFilter,
    setGlobalFilter,
    dropdowns,
    searchHandler,
    rowList,
    currentPage,
    currPageSize,
    rowCount,
    onBack,
    userPermissions
}) => {

    const [filterCount, setFilterCount] = useState();
    const [loader, setLoader] = useState(false)


    const ref = useRef();

    const createUpdateHandler = async (rowForm) => {
        try {
            setLoader(true);
            const updatedRowForm = updateRequest({
                ...rowForm,
                effectiveFrom: rowForm?.effectiveFrom && moment(rowForm?.effectiveFrom).format('YYYY-MM-DD')
            })
            const reqObj = {
                careerType: globalFilter?.career?.value,
                term: globalFilter?.term?.value,
                rules: [
                    { ruleId: null, ...updatedRowForm }
                ]
            }
            let url = `${endpoint.refund.refundPolicies}`;
            let method = 'post';

            // if (!rowForm?.isNew) {
            //     url = `${endpoint.concessionConfigArpu.crud}/${CONFIG_TYPE}`;
            //     method = 'put'
            // }
            const resp = await fetchAllPostPromisedData(url, reqObj, method);
            if (resp?.code === 200) {
                searchHandler({})
                successToast('Request completed successfully!!!')
                ref.current.stopEditing();
            }
        } catch (err) {
            console.error(err);
        }
        finally {
            setLoader(false)
        }
    }

    const deleteHandler = async (rowForm) => {
        try {
            setLoader(true);
            const reqObj = updateRequest({
                ...rowForm,
                status: 'DELETED'
            })
            let url = `${endpoint.refund.refundPolicies}`;
            let method = 'post';

            // if (!rowForm?.isNew) {
            //     url = `${endpoint.concessionConfigArpu.crud}/${CONFIG_TYPE}`;
            //     method = 'put'
            // }
            const resp = await fetchAllPostPromisedData(url, reqObj, method);
            if (resp?.code === 200) {
                searchHandler({})
                successToast('Request completed successfully!!!')
                ref.current.stopEditing();
            }
        } catch (err) {
            console.error(err);
        }
        finally {
            setLoader(false)
        }
    };

    return (
        <Card className='ml-3 mr-3 mt-3'>
            <CardBody>

                <div className=" d-flex heading-4 color-dark align-items-center justify-content-between "
                //   style={headerStyle}
                >

                    <div className="d-flex align-items-center">
                        <div><BackArrow className='mr-2 cursor' onClick={onBack} /></div>
                        <h3 className='mt-2 mr-3'>Week wise calculation logic</h3>
                        {globalFilter?.term && globalFilter?.career && (
                            <CustomChip
                                text={`Term - ${globalFilter?.term?.label ?? globalFilter?.term?.value} / Career - ${globalFilter?.career?.label ?? globalFilter?.career?.value}`}
                                textColor={'#07314A'}
                                bgColor={'#E6F7FF'}
                            />
                        )}
                    </div>
                    <div className='d-flex align-items-start justify-content-center'>

                        <APopover
                            buttonComponent={(openPopover, styles) => (
                                <AButton
                                    className="tiny-semi-bold color-dark"
                                    onClick={openPopover}
                                    variant='general'
                                    size="sm"
                                    updatedStyle={{
                                        minWidth: "61px",
                                        ...(filterCount > 0
                                            ? {
                                                border: "1px solid #00B0F5",
                                                color: "#00B0F5",
                                            }
                                            :
                                            styles),
                                    }}
                                >
                                    Filters
                                    {filterCount > 0 ? `(${filterCount})` : ""}
                                </AButton>
                            )}
                            menuComponent={(closePopup) =>
                                <Filters
                                    closePopup={closePopup}
                                    formFields={getFilterFormFields(dropdowns)}
                                    searchHandler={searchHandler}
                                    filterCount={filterCount}
                                    setFilterCount={setFilterCount}
                                    globalFilter={globalFilter}
                                    setGlobalFilter={setGlobalFilter}
                                />
                            }
                        />
                        {userPermissions?.includes("C")&&<AButton
                            className="tiny-semi-bold color-dark"
                            size="sm"
                            updatedStyle={{
                                minWidth: "61px",
                            }}
                            variant="primary_filled"
                        >
                            <span className='d-flex justify-content-center align-items-center'
                                style={{ gap: '10px' }}
                                onClick={() => ref.current.addNewRow()}
                            >
                                Add +
                            </span>
                        </AButton>
                        }

                    </div>
                </div>
                <div className='mt-24 mx-0' style={{ borderBottom: " 1px solid #E2E2E2" }}></div>
                <ListComponent
                    rows={rowList}
                    ref={ref}
                    dropdowns={dropdowns}
                    createUpdateHandler={createUpdateHandler}
                    loader={loader}
                    setLoader={setLoader}
                    //setDropdowns={setDrop}
                    // deleteHandler={deleteHandler}
                    totalRecords={rowCount}
                    currentPageSize={currPageSize}
                    currentPage={currentPage}
                    searchArpuList={searchHandler}
                    userPermissions={userPermissions}
                />

            </CardBody>
        </Card>
    )
}
export default WeekwiseCalculationList;